import React from "react";
import styled from "styled-components";
import {getServiceTypeName} from "utils/define";
import {getPercent, getCommaNumber} from "utils/format";



/**
 * [이용권 종류별 개요]
 */

export const SummaryInfo = ({data}) => {
	const serviceTypeList = ["appointment", "class", "place", "option", "package"];

	const getChartList = () => {
		const li = [];
		serviceTypeList.forEach(item => {
			const amount = data[item + "SalesAmount"] || data[item + "SaleAmount"];
			const percent = getPercent(amount, data.totalSalesAmount, 2);
			if(amount) {
				li.push(<li key={item} className={"bg-" + item} style={{width : percent + "%"}} />);
			}
		});
		if(!li.length) {
			li.push(<li className="empty" key="empty" />);
		}
		return (<ul>{li}</ul>);
	};
	const getSummaryList = () => {
		const li = serviceTypeList.map(item => {
			const amount = data[item + "SalesAmount"] || data[item + "SaleAmount"];
			const percent = data[item + "SalesPercent"] || data[item + "SalePercent"] || 0;
			// const percent = getPercent(amount, data.totalSalesAmount, 2);
			return (
				<li key={item}>
					<div>
						<span className={"spot bg-" + item} />
						<span>{getServiceTypeName(item)}</span>
						<span className={"percent " + item}>{percent}%</span>
					</div>
					<div>{getCommaNumber(amount)}원</div>
				</li>
			);
		});
		return (<ul className="color">{li}</ul>);
	};
	return (
		<Wrapper>
			<div className="chartInfo">
				{getChartList()}
			</div>
			<div className="summaryInfo">
				{getSummaryList()}
			</div>
		</Wrapper>
	);
};

const Wrapper = styled.div`
.chartInfo							{padding:32px 0 24px !important}
.chartInfo ul						{display:flex; margin:0 -1.5px; height:20px; border-radius:6px; overflow:hidden}
.chartInfo ul li					{margin:0 1.5px}
.chartInfo ul li.empty				{width:100%; background-color:var(--gray); opacity:0.33}

.bg-appointment						{background-color:var(--appointment)}
.bg-class							{background-color:var(--class)}
.bg-place							{background-color:var(--place)}
.bg-option							{background-color:var(--option)}
.bg-package							{background-color:var(--package)}

.summaryInfo						{margin:0 !important; padding:0 !important; border:none !important}
.summaryInfo li div:first-child		{display:flex; align-items:center}
.summaryInfo li .percent			{font-size:var(--14px); font-weight:400}
.summaryInfo li .percent:before		{content:"·"; margin:0 0.25em; color:var(--black)}
.summaryInfo li .spot				{margin-right:5px; width:8px; height:8px; border-radius:100%}
.summaryInfo li + li				{margin-top:8px}
.summaryInfo li div + div			{font-weight:600}
`;

export default SummaryInfo;